module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/070cb59572afba5416e21e732d098557.png";